import LegalPageLayout from "@/components/legal/LegalPageLayout";

export default function RefundPolicy() {
  return (
    <LegalPageLayout title="Refund &amp; Cancellation Policy" testId="refund-policy-page">
      <p>
        Donations to Animal Matter To Me ("AMTM") are generally <strong>non-refundable</strong>, as they are put
        to use in our rescue, treatment, and sheltering programmes as soon as they are received.
      </p>

      <h2>Erroneous or duplicate transactions</h2>
      <p>
        If you made a donation in error, or were accidentally charged twice for the same donation, we will refund
        it if you write to us <strong>within 7 days of the transaction</strong>, at the email address on our{" "}
        <a href="/contact">Contact Us</a> page, with your transaction details (date, amount, and payment
        reference/order ID if available). Approved refunds are processed back to your original payment method and
        may take 5-7 business days to reflect, depending on your bank or payment provider.
      </p>

      <h2>Cancelling a recurring (Guardian) donation</h2>
      <p>
        You can cancel your monthly Guardian donation <strong>anytime</strong>, at no cost, either from your donor
        portal at <code>/my-giving</code>, or by writing to us. Cancellation takes effect from your{" "}
        <strong>next billing cycle</strong> - any amount already charged for the current cycle is not refunded,
        consistent with our general non-refundable donation policy above.
      </p>

      <h2>How to reach us</h2>
      <p>
        For any refund, cancellation, or billing question, please see our <a href="/contact">Contact Us</a> page
        for our email and phone number.
      </p>
    </LegalPageLayout>
  );
}
